export const DEBOUNCE_DEFAULT_DELAY = 400

export const THEMES = {
  WHITES: 'whites',
  LIGHT_GREY: 'light-grey',
  SOFT_GREY: 'soft-grey',
  SLATE: 'slate',
  DARK_SLATE: 'dark-slate',
  RAIN: 'rain',
  STEEL: 'steel',
  Q4_BLUE: 'q4-blue',
  INK: 'ink',
  TEAL: 'teal',
  CITRUS: 'citrus',
  TRANSPARENT: 'transparent'
}
